
  document.addEventListener("DOMContentLoaded", function() {
    
    console.log("[AD-DEBUG] Script gestartet. Warte auf DOM...");

    const adPool = document.getElementById('ad-pool-storage');
    const slots = document.querySelectorAll('.ad-slot-target');
    
    // 1. Diagnose: Pool prüfen
    if (!adPool) {
      console.error("[AD-DEBUG] FEHLER: Pool (#ad-pool-storage) nicht gefunden! Ist die Einstellung 'show_ads' an?");
      return;
    } else {
      // Prüfen, ob der Pool versteckt ist (sollte er sein, aber nicht display: none)
      console.log("[AD-DEBUG] Pool gefunden. Display Style:", window.getComputedStyle(adPool).display);
      console.log("[AD-DEBUG] Pool Visibility:", window.getComputedStyle(adPool).visibility);
    }

    // 2. Diagnose: Kandidaten prüfen
    let candidates = Array.from(adPool.querySelectorAll('.ad-candidate'));
    console.log(`[AD-DEBUG] Kandidaten (Ads) im Pool gefunden: ${candidates.length}`);
    
    if (candidates.length === 0) {
      console.warn("[AD-DEBUG] WARNUNG: Pool ist da, aber leer. Keine Ads definiert?");
      return;
    }

    // 3. Diagnose: Slots prüfen
    console.log(`[AD-DEBUG] Ziel-Slots im Grid gefunden: ${slots.length}`);
    if (slots.length === 0) {
      console.warn("[AD-DEBUG] WARNUNG: Keine Slots (.ad-slot-target) gefunden. Frequenz zu hoch oder Loop falsch?");
      return;
    }

    // Shuffle Funktion
    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
    
    shuffleArray(candidates);
    console.log("[AD-DEBUG] Kandidaten gemischt.");

    // 4. Verteilen
    slots.forEach((slot, index) => {
      console.log(`[AD-DEBUG] Verarbeite Slot ${index + 1}...`);
      
      const candidateIndex = index % candidates.length;
      const originalWrapper = candidates[candidateIndex];
      
      // Sicherheitscheck: Ist da wirklich ein Element drin?
      if (!originalWrapper || !originalWrapper.firstElementChild) {
         console.error(`[AD-DEBUG] FEHLER bei Slot ${index}: Kandidat ist leer oder ungültig.`);
         return;
      }

      // Wir klonen das <a> Tag
      const originalCard = originalWrapper.firstElementChild;
      const selectedAdClone = originalCard.cloneNode(true);

      // Slot sichtbar schalten
      slot.style.display = 'block';
      slot.appendChild(selectedAdClone);
      console.log(`[AD-DEBUG] Slot ${index + 1} befüllt und sichtbar gemacht.`);

      // --- iOS VIDEO FIX ---
      const video = selectedAdClone.querySelector('video');
      
      if (video) {
        console.log(`[AD-DEBUG] Video in Slot ${index + 1} entdeckt. Versuche Autoplay...`);
        
        // Harte Attribute setzen für Safari
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.loop = true;

        // Safari braucht manchmal ein .load(), wenn das Element geklont wurde
        video.load();

        // Promise Play
        const playPromise = video.play();

        if (playPromise !== undefined) {
            playPromise
              .then(() => {
                console.log(`[AD-DEBUG] ✅ Video Slot ${index + 1}: Autoplay erfolgreich!`);
              })
              .catch(error => {
                console.error(`[AD-DEBUG] ❌ Video Slot ${index + 1}: Autoplay fehlgeschlagen!`, error);
                
                // Fallback: Wenn Autoplay blockiert wird, zeig das Poster (falls vorhanden)
                // oder versuche es mit User-Interaktion (was wir hier nicht können)
                console.log("[AD-DEBUG] Prüfe Fehlerursache: Oft 'NotAllowedError' (Low Power Mode) oder 'AbortError'.");
              });
        }
      } else {
        console.log(`[AD-DEBUG] Kein Video in Slot ${index + 1} (ist wohl ein Bild).`);
      }
    });
    
    console.log("[AD-DEBUG] Script durchgelaufen.");
  });
